<template>
    <v-card class="survey fill-height">
        <v-card-title primary-title>
            <v-icon @click="back" class="icon-back">
                keyboard_arrow_left
            </v-icon>
            <div class="title-description">
                <div class="headline">{{ checkEmptyTranslation(selectedSurvey.name) }}</div>
                <div v-if="selectedSurvey.instructions"><b>Description :</b> <span v-html="selectedSurvey.instructions"></span></div>
            </div>
            <v-spacer></v-spacer>

            <template>
                <v-tooltip bottom v-if="$route.name === 'survey.view' && !selectedSurvey.archived">
                    <template v-slot:activator="{ on }">
                        <v-btn @click="archive" flat v-on="on">
                            <v-icon>archive</v-icon>
                        </v-btn>
                    </template>
                    <span>Archiver</span>
                </v-tooltip>
                <v-tooltip bottom v-if="$route.name === 'survey.view' && selectedSurvey.archived">
                    <template v-slot:activator="{ on }">
                        <v-btn  @click="unarchive" flat v-on="on">
                            <v-icon>restore</v-icon>
                        </v-btn>
                    </template>
                    <span>Désarchiver</span>
                </v-tooltip>
                <v-btn v-if="$route.name === 'survey.view'" flat @click="editSurvey()" :disabled="selectedSurvey.archived">
                    <v-icon>edit</v-icon>
                </v-btn>
                <v-btn v-if="$route.name === 'survey.view'" flat @click="deleteDialog = true" :disabled="selectedSurvey.archived">
                    <v-icon>delete</v-icon>
                </v-btn>
            </template>
            <survey-language-selector/>
<!--            <td class="text-xs-right">-->
<!--                <v-btn right color="primary" @click="exportStudy">-->
<!--                    Export-->
<!--                </v-btn>-->
<!--            </td>-->
        </v-card-title>

        <v-divider></v-divider>

        <router-view></router-view>

        <v-dialog v-model="deleteDialog" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">Supprimer le questionnaire</v-card-title>
                <v-card-text>Voulez-vous vraiment supprimer le questionnaire ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                    <v-btn color="primary" text @click="deleteSurvey()">Oui, supprimer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import {getTranslationString} from "../../helper";
import SurveyLanguageSelector from "./components/SurveyLanguageSelector";
import {checkEmptyTranslation} from "../../i18n";

export default {
    name: "SurveyView",
    components: {SurveyLanguageSelector},
    computed: {
        ...mapState(
            'surveys',
            {
                selectedSurvey: state => state.selected_score,
                language: state => state.currentLanguage,
            }
        ),
    },
    data() {
        return {
            deleteDialog: false,
        }
    },
    created() {
        this.setSelectedScoreId(this.$route.params.id)
        this.getScoreInfo()
    },
    methods: {
        checkEmptyTranslation,
        back() {
            this.$router.back()
        },
        ...mapActions('surveys', [
            'getScoreInfo',
            'postDeleteScore',
            'archive',
            'unarchive',
        ]),
        ...mapMutations('surveys', [
            'setSelectedScoreId'
        ]),
        getText(key) {
            return getTranslationString(key)
        },
        editSurvey() {
            this.dialog = false;
            this.$router.push({
                name: 'survey.edit'
            })
        },

        deleteSurvey() {
            this.deleteDialog = false;
            this.postDeleteScore(this.selectedSurvey).then(response => {
                    this.$router.replace({name: 'surveys'})
                }
            ).catch(reason => {
            })
        },
    },
    watch: {
        language() {
            if (this.$route.params.id) {
                this.getScoreInfo()
            }
        }
    }
}
</script>

<style scoped>
    .title-description {
        max-width: 60%;
    }
</style>

